```vue
<template>
    <!-- 申请提现 -->
    <div>
        <ZhaiHead />
        <div class="container-fluid zhu px-0">
            <div class="row shengse">
                <!-- 顶部栏 -->
                <div class="dixian px-4 py-2 top-bar">
                    <div class="promo-title" @click="goBack">
                        <i class="fa fa-bullhorn"></i>推广中心
                    </div>
                    <div class="top-center-title" @click="goMyWallet">我的钱包</div>
                    <div class="top-right" @click="goMyWallet">
                        钱包 <span class="arrow">›</span>
                    </div>
                </div>

                <!-- 提现账户设置 -->
                <div class="withdraw-row px-4" @click="goSetting">
                    <div class="withdraw-left">
                        <i class="fa fa-credit-card"></i>
                        <span class="withdraw-title">提现账户</span>
                    </div>
                    <div class="withdraw-right">设置 <span class="arrow">›</span></div>
                </div>

                <!-- 页面主体 -->
                <div class="wallet-page">
                    <!-- 当前账户 -->
                    <div class="wallet-card">
                        <div class="card-row">
                            <div class="left">
                                <!-- ✅ 左侧账户图标：与弹窗列表完全一致 -->
                                <div class="account-icon" :class="accountVisual(currentAccount.type).wrapClass">
                                    <!-- 支付宝：显示“支” -->
                                    <span
                                            v-if="accountVisual(currentAccount.type).mode === 'text'"
                                            class="account-icon-text"
                                    >
                                        {{ accountVisual(currentAccount.type).text }}
                                    </span>

                                    <!-- usdt/bank：显示 font-awesome 图标 -->
                                    <i
                                            v-else
                                            class="fa"
                                            :class="accountVisual(currentAccount.type).iconClass"
                                    ></i>
                                </div>

                                <div class="value">
                                    <div class="value-main">
                                        <span class="account-title">{{ currentAccount.title || "未选择账户" }}</span>
                                        <span v-if="currentAccount.name" class="account-name">
                                            {{ currentAccount.name }}
                                        </span>
                                    </div>

                                    <div class="value-sub">
                                        {{ displayDesc(currentAccount) || "请先设置提现账户" }}
                                    </div>
                                </div>
                            </div>

                            <div class="right action" @click="openAccountPopup">
                                切换 <span class="arrow">›</span>
                            </div>
                        </div>
                    </div>

                    <!-- 提现金额 -->
                    <div class="wallet-card">
                        <div class="card-head">
                            <div class="head-left">提现金额</div>
                            <div class="head-right">提现收取5%手续费</div>
                        </div>

                        <div class="amount-row">
                            <div class="amount-label">提现金额</div>
                            <div class="amount-input">
                                <input
                                        v-model="amount"
                                        type="number"
                                        inputmode="decimal"
                                        placeholder="请输入提现金额"
                                />
                                <span class="unit">元</span>
                            </div>
                        </div>

                        <div class="sub-row">
                            <div class="sub-left">
                                可提现金额 {{ Number(available || 0).toFixed(2) }} 元（满1000元可提现）
                            </div>
                            <div class="sub-right" @click="withdrawAll">全部提现</div>
                        </div>
                    </div>

                    <div class="submit-wrap">
                        <button class="submit-btn" :disabled="submitDisabled" @click="submitWithdraw">
                            提交
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ============== 底部账户切换弹窗（保持贴底，不改结构） ============== -->
        <transition name="fade">
            <div v-if="showAccountPopup" class="mask" @click.self="closeAccountPopup">
                <transition name="slide-up">
                    <div class="popup" @click.stop>
                        <div class="popup-title">
                            请选择提现账户
                            <span class="popup-setting" @click="goSetting">设置</span>
                        </div>

                        <div class="popup-list">
                            <div
                                    class="popup-item"
                                    v-for="item in withdrawAccounts"
                                    :key="item.id"
                                    :class="{ active: item.id === currentAccount.id }"
                                    @click="selectAccount(item)"
                            >
                                <div class="item-left">
                                    <div class="account-icon small" :class="accountVisual(item.type).wrapClass">
                                        <span
                                                v-if="accountVisual(item.type).mode === 'text'"
                                                class="account-icon-text"
                                        >
                                            {{ accountVisual(item.type).text }}
                                        </span>
                                        <i
                                                v-else
                                                class="fa"
                                                :class="accountVisual(item.type).iconClass"
                                        ></i>
                                    </div>

                                    <div class="item-text">
                                        <div class="item-title">
                                            {{ item.title }}
                                            <span v-if="item.name" class="item-name">{{ item.name }}</span>
                                        </div>

                                        <div class="item-desc" :class="{ ellipsis: item.type === 'usdt' }">
                                            {{ displayDesc(item) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="item-right">
                                    <i
                                            v-if="item.id === currentAccount.id"
                                            class="fa fa-check check"
                                            aria-hidden="true"
                                    ></i>
                                    <span v-else class="chevron">›</span>
                                </div>
                            </div>
                        </div>

                        <div class="popup-cancel" @click="closeAccountPopup">取消</div>
                        <div class="safe-bottom"></div>
                    </div>
                </transition>
            </div>
        </transition>

        <ZhaiFoot />
    </div>

    <!-- ========== ✅ 提示弹窗：居中显示（只改 class，不改层级） ========== -->
    <transition name="fade">
        <div v-if="showNoAccountModal" class="mask mask-center">
            <div class="no-account-modal">
                <div class="modal-title">请设置提现账户</div>
                <div class="modal-desc">
                    设置提现收款账户后才能申请提现<br />
                    即将跳转至设置页面
                </div>
                <div class="modal-btn" @click="confirmGoSetting">确定</div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="showBalanceGateModal" class="mask mask-center" @click.self="showBalanceGateModal=false">
            <div class="no-account-modal">
                <div class="modal-title">暂不可提现</div>
                <div class="modal-desc">
                    当前可提现余额未满 1000 元<br />
                    满 1000 元后可提交提现
                </div>
                <div class="modal-btn" @click="showBalanceGateModal=false">知道了</div>
            </div>
        </div>
    </transition>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import http from "../utils/http.js";

    export default {
        name: "MWalletWithdrawal",
        components: { ZhaiHead, ZhaiFoot },

        data() {
            return {
                /** ====== API 路径（与 PC 保持一致）====== */
                API_PROFILE: "/platform/withdraw/profile",
                API_BALANCE: "/platform/withdraw/balance",
                API_WITHDRAW_APPLY: "/platform/withdraw/apply",

                /** ✅ 规则：余额/可提现金额满 1000 元才允许提现（与 PC 一致） */
                MIN_WITHDRAW_YUAN: 1000,

                // ===== 页面状态 =====
                amount: "",
                available: 0.0, // 元

                showAccountPopup: false,
                showNoAccountModal: false,
                showBalanceGateModal: false,

                // ===== 用户/账户数据 =====
                currentUserId: null,

                /** withdraw_profile 原始数据（与 PC 一致） */
                profile: {
                    realName: "",
                    bankName: "",
                    bankCardNo: "",
                    alipayAccount: "",
                    usdtAddress: "",
                },

                withdrawAccounts: [],

                /** 当前选中账户（保持 template 所需字段） */
                currentAccount: {
                    id: "",
                    type: "",
                    title: "",
                    name: "",
                    desc: "",
                    raw: {},
                },
            };
        },

        computed: {
            /** ✅ 是否达到提现门槛（余额≥1000） */
            canWithdrawByBalance() {
                return Number(this.available || 0) >= this.MIN_WITHDRAW_YUAN;
            },

            submitDisabled() {
                const a = Number(this.amount || 0);
                if (!this.currentAccount || !this.currentAccount.type) return true;
                if (!this.canWithdrawByBalance) return true; // 与 PC 一致：门槛不足不可提交
                if (!a || a <= 0) return true;
                if (a > Number(this.available || 0)) return true;
                return false;
            },
        },

        /** ✅ 路由守卫：未登录直接跳登录页（与 PC 一致） */
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // mounted 兜底：防守卫失效/直开页面
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();

            await this.loadWithdrawProfile();
            await this.loadWithdrawBalance();

            // ✅ 注意：页面加载不弹 “余额未满1000” 弹窗（保持你手机端原逻辑）
        },

        beforeUnmount() {
            this.unlockBodyScroll();
        },

        methods: {
            /** ========== 统一：登录失效处理 ========== */
            redirectToLogin() {
                this.unlockBodyScroll();
                this.$router.replace("/login");
            },

            /** ========== 判断 token 是否过期（与 PC 同风格） ========== */
            isAuthExpired(err, json) {
                const statusCode = err?.response?.status;
                if (statusCode === 401 || statusCode === 403) return true;

                const s = json?.status;
                if (s === 401 || s === 403 || s === -1) return true;

                const msg = String(json?.msg || err?.message || "");
                if (/token|登录|未登录|过期|失效|unauthorized|forbidden/i.test(msg)) return true;

                return false;
            },

            /** ========== body 滚动锁定（手机端保持原体验） ========== */
            lockBodyScroll() {
                document.body.style.overflow = "hidden";
            },
            unlockBodyScroll() {
                document.body.style.overflow = "";
            },

            /** ========== 稳健拿 userId（与 PC 一致：有就传；没有就让后端 token 兜底） ========== */
            resolveUserIdSafe() {
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            /** ========== 由 profile 生成可提现账户列表（与 PC 一致） ========== */
            buildAccountsFromProfile(p) {
                const list = [];
                const realName = (p.realName || "").trim();
                const bankName = (p.bankName || "").trim();
                const bankCardNo = (p.bankCardNo || "").trim();
                const alipay = (p.alipayAccount || "").trim();
                const usdt = (p.usdtAddress || "").trim();

                if (realName && bankName && bankCardNo) {
                    list.push({
                        id: "bank",
                        type: "bank",
                        title: "银行账户",
                        name: realName,
                        desc: `${bankName} | ${bankCardNo}`,
                        raw: { realName, bankName, bankCardNo },
                    });
                }
                if (alipay) {
                    list.push({
                        id: "alipay",
                        type: "alipay",
                        title: "支付宝账户",
                        name: realName || "",
                        desc: alipay,
                        raw: { realName, alipayAccount: alipay },
                    });
                }
                if (usdt) {
                    list.push({
                        id: "usdt",
                        type: "usdt",
                        title: "USDT账号",
                        name: realName || "",
                        desc: usdt,
                        raw: { realName, usdtAddress: usdt },
                    });
                }
                return list;
            },

            /** 默认账户优先级（与 PC 一致）：usdt > alipay > bank */
            pickDefaultAccount(list) {
                return (
                    list.find((x) => x.type === "usdt") ||
                    list.find((x) => x.type === "alipay") ||
                    list.find((x) => x.type === "bank") ||
                    list[0]
                );
            },

            applyCurrentAccount(item) {
                if (!item) return;
                this.currentAccount.id = item.id;
                this.currentAccount.type = item.type;
                this.currentAccount.title = item.title;
                this.currentAccount.name = item.name || "";
                this.currentAccount.desc = item.desc || "";
                this.currentAccount.raw = item.raw || {};
            },

            /** ========== 1) 拉提现账户（对齐 PC 的 /withdraw/profile） ========== */
            async loadWithdrawProfile() {
                try {
                    const uid = this.currentUserId || null;
                    const params = uid ? { userId: uid } : null;

                    const res = await http.get(this.API_PROFILE, params);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        console.error("[withdraw_profile] api failed:", json);
                        return;
                    }

                    const d = json.data || {};
                    this.profile.realName = d.realName || d.real_name || "";
                    this.profile.bankName = d.bankName || d.bank_name || "";
                    this.profile.bankCardNo =
                        d.bankCardNo || d.bank_card_no || d.bankAccount || d.bank_account || "";
                    this.profile.alipayAccount = d.alipayAccount || d.alipay_account || "";
                    this.profile.usdtAddress = d.usdtAddress || d.usdt_address || "";

                    const list = this.buildAccountsFromProfile(this.profile);
                    this.withdrawAccounts = list;

                    if (!list || list.length === 0) {
                        this.showNoAccountModal = true;
                        // 手机端是居中弹窗，不锁也行；这里锁一下避免底层滚动（更稳）
                        this.lockBodyScroll();
                        return;
                    }

                    const def = this.pickDefaultAccount(list);
                    this.applyCurrentAccount(def);
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[withdraw_profile] exception:", e);
                }
            },

            /** ========== 2) 拉可提现余额（对齐 PC：availableCent/balanceCent） ========== */
            async loadWithdrawBalance() {
                try {
                    const uid = this.currentUserId || null;
                    const params = uid ? { userId: uid } : null;

                    const res = await http.get(this.API_BALANCE, params);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        console.error("[withdraw_balance] api failed:", json);
                        return;
                    }

                    const d = json.data || {};

                    // ✅ 兼容后端字段：availableCent / balanceCent
                    const cent = Number(
                        d.availableCent ?? d.balanceCent ?? d.available_cent ?? d.balance_cent ?? 0
                    );

                    this.available = Math.max(0, cent / 100);
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[withdraw_balance] exception:", e);
                }
            },

            /** ========== 弹窗/切换账户（保持手机端原交互） ========== */
            openAccountPopup() {
                if (!this.withdrawAccounts || this.withdrawAccounts.length === 0) {
                    this.showNoAccountModal = true;
                    this.lockBodyScroll();
                    return;
                }
                this.showAccountPopup = true;
                this.lockBodyScroll();
            },
            closeAccountPopup() {
                this.showAccountPopup = false;
                this.unlockBodyScroll();
            },
            selectAccount(item) {
                this.applyCurrentAccount(item);
                this.closeAccountPopup();
            },

            /** 无账户提示弹窗 */
            confirmGoSetting() {
                this.showNoAccountModal = false;
                this.unlockBodyScroll();
                this.$router.replace("/WalletSettings");
            },

            /** ========== 页面跳转（保持原功能） ========== */
            goBack() {
                if (window.history.length > 1) window.history.back();
                else window.location.href = "/Promotion";
            },
            goMyWallet() {
                this.$router.push("/MyWallet");
            },
            goSetting() {
                this.$router.push("/WalletSettings");
            },

            /** ✅ 全部提现：余额不足1000时弹你原来的门槛弹窗（与 PC 的 alert 等价，但不改手机端体验） */
            withdrawAll() {
                if (!this.canWithdrawByBalance) {
                    this.showBalanceGateModal = true;
                    return;
                }
                if (Number(this.available || 0) <= 0) return;
                this.amount = Number(this.available || 0).toFixed(2);
            },

            /** ✅ 提交提现：完全对齐 PC 的 /withdraw/apply 逻辑 + 提交前刷新余额 */
            async submitWithdraw() {
                // 0) token 兜底
                const token = localStorage.getItem("token");
                if (!token) {
                    this.redirectToLogin();
                    return;
                }

                // 1) 校验账户
                if (!this.currentAccount || !this.currentAccount.type) {
                    this.showNoAccountModal = true;
                    this.lockBodyScroll();
                    return;
                }

                // 2) 提交前重新拉一次余额（防并发/防抓包）——与 PC 一致
                await this.loadWithdrawBalance();

                // loadWithdrawBalance 内可能触发 redirect
                if (!localStorage.getItem("token")) return;

                // 3) ✅ 门槛校验：按钮本来就 disabled，这里再兜底一次（提交时不弹门槛弹窗，保持你原需求）
                if (!this.canWithdrawByBalance) {
                    return;
                }

                // 4) 金额校验
                const a = Number(this.amount || 0);
                if (!a || a <= 0) return;

                if (a > Number(this.available || 0)) {
                    window.alert("提现金额超过可提现余额");
                    return;
                }

                // 5) 提现方式映射：1 = 银行卡，2 = 支付宝，3 = USDT（与 PC 一致）
                const method = this.currentAccount.type === "bank" ? 1 : this.currentAccount.type === "alipay" ? 2 : 3;

                // 6) 元 -> 分（整数）（与 PC 一致）
                const requestCent = Math.round(a * 100);

                // 7) 组装 body（与 PC 一致字段）
                const body = {
                    method,
                    requestCent,
                    realName: this.currentAccount.raw?.realName || this.profile.realName || "",
                    bankName: this.currentAccount.raw?.bankName || "",
                    bankCardNo: this.currentAccount.raw?.bankCardNo || "",
                    alipayAccount: this.currentAccount.raw?.alipayAccount || "",
                    usdtAddress: this.currentAccount.raw?.usdtAddress || "",
                };

                try {
                    const uid = this.currentUserId;
                    const url = uid ? `${this.API_WITHDRAW_APPLY}?userId=${uid}` : this.API_WITHDRAW_APPLY;

                    const res = await http.post(url, body);
                    const json = res?.data;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || json.status !== 1) {
                        window.alert(json?.msg || "提交失败");
                        return;
                    }

                    window.alert("提交成功，已进入审核流程");
                    this.amount = "";

                    // 提交成功后刷新余额（与 PC 一致）
                    await this.loadWithdrawBalance();
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    console.error("[withdraw_apply] exception:", e);
                    window.alert("提交失败，请稍后再试");
                }
            },

            /** ========== 图标映射（保持你原逻辑） ========== */
            accountVisual(type) {
                const map = {
                    usdt: { mode: "icon", iconClass: "fa-diamond", wrapClass: "account-icon-usdt" },
                    alipay: { mode: "text", text: "支", wrapClass: "account-icon-alipay" },
                    bank: { mode: "icon", iconClass: "fa-university", wrapClass: "account-icon-bank" },
                };
                return map[type] || map.bank;
            },

            /** ========== 展示脱敏（保持你原逻辑） ========== */
            displayDesc(item) {
                if (!item || !item.desc) return "";

                if (item.type === "bank") {
                    const parts = String(item.desc).split("|").map((s) => s.trim());
                    if (parts.length >= 2) return `${parts[0]} | ${this.maskBankCard(parts[1])}`;
                    return this.maskBankCard(item.desc);
                }
                if (item.type === "alipay") return this.maskPhone(item.desc);
                return String(item.desc);
            },

            maskPhone(str) {
                const s = String(str).replace(/\s/g, "");
                if (/^\d{11}$/.test(s)) return s.slice(0, 3) + "****" + s.slice(7);
                if (s.length <= 4) return s;
                return s.slice(0, 2) + "****" + s.slice(-2);
            },

            maskBankCard(str) {
                const digits = String(str).replace(/\s/g, "");
                if (digits.length <= 8) return digits;
                return `${digits.slice(0, 4)} **** **** ${digits.slice(-4)}`;
            },
        },
    };
</script>

<style scoped>
    .fa { margin-right: 6px; }

    .zhu {
        margin-top: 80px;
        height: calc(100vh - 80px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* 顶部栏 */
    .top-bar {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }

    .top-center-title {
        justify-self: center;
        font-size: 16px;
        font-weight: 700;
        color: #00c26f;
    }

    .top-right {
        justify-self: end;
        font-size: 14px;
        color: #00c26f;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .promo-title {
        font-size: 16px;
        color: #333;
        cursor: pointer;
    }
    .promo-title:active { opacity: 0.7; }

    /* 提现账户行 */
    .withdraw-row {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #efefef;
        cursor: pointer;
    }
    .withdraw-row:active { opacity: 0.8; }

    .withdraw-left {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
        color: #333;
    }
    .withdraw-left .fa {
        margin-right: 0;
        font-size: 16px;
        color: #bfbfbf;
    }
    .withdraw-title { font-weight: 400; }

    .withdraw-right {
        font-size: 14px;
        color: #2f6fed;
    }

    .arrow {
        margin-left: 4px;
        font-size: 18px;
        color: #aaa;
    }

    /* 页面背景 */
    .wallet-page {
        width: 100%;
        flex: 1;
        background: #efefef;
        overflow-y: auto;
    }

    /* 卡片 */
    .wallet-card {
        background: #fff;
        border-radius: 2px;
        padding: 14px;
        margin: 0 2px 12px;
        box-shadow: 0 0 0 1px rgba(0,0,0,0.04);
    }

    .card-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /* 左侧区域：图标 + 文字 */
    .left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
    }

    /* 统一账户图标块 */
    .account-icon {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        background: #fff;
        border: 2px solid #ff6b6b;
    }
    .account-icon .fa {
        margin-right: 0;
        font-size: 18px;
        color: #ff6b6b;
    }
    .account-icon-text {
        font-size: 18px;
        font-weight: 800;
        line-height: 1;
    }

    /* 弹窗里小一点 */
    .account-icon.small {
        width: 38px;
        height: 38px;
        border-radius: 10px;
    }
    .account-icon.small .fa { font-size: 16px; }
    .account-icon.small .account-icon-text { font-size: 16px; }

    /* usdt */
    .account-icon-usdt { border-color: #16a085; }
    .account-icon-usdt .fa, .account-icon-usdt .account-icon-text { color: #16a085; }

    /* alipay */
    .account-icon-alipay { border-color: #2f6fed; }
    .account-icon-alipay .fa, .account-icon-alipay .account-icon-text { color: #2f6fed; }

    /* bank */
    .account-icon-bank { border-color: #ff6b6b; }
    .account-icon-bank .fa, .account-icon-bank .account-icon-text { color: #ff6b6b; }

    /* 两行布局 */
    .left .value {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    }

    /* 第一行 */
    .value-main {
        display: flex;
        align-items: baseline;
        gap: 6px;
    }
    .account-title {
        font-size: 16px;
        font-weight: 700;
        color: #111;
    }
    .account-name {
        font-size: 14px;
        font-weight: 400;
        color: #999;
    }

    /* 第二行 */
    .value-sub {
        font-size: 13px;
        font-weight: 400;
        color: #999;
        padding-left: 2px;
        min-width: 0;
        word-break: break-all;
    }
    .item-name {
        margin-left: 6px;
        font-size: 13px;
        font-weight: 400;
        color: #999;
    }

    .right.action {
        font-size: 14px;
        color: #999;
        cursor: pointer;
    }
    .right.action:active { opacity: 0.7; }

    /* 提现卡片 */
    .card-head {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid #f0f0f0;
        margin-bottom: 12px;
    }
    .head-left { font-size: 14px; color: #999; }
    .head-right { font-size: 13px; color: #ff4d4f; }

    .amount-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0 10px;
    }
    .amount-label {
        font-size: 16px;
        font-weight: 700;
    }
    .amount-input {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: flex-end;
    }
    .amount-input input {
        width: 100%;
        border: none;
        outline: none;
        font-size: 16px;
        background: transparent;
        text-align: right;
    }
    .unit { margin-left: 8px; color: #999; }

    .sub-row {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #f7f7f7;
        padding-top: 8px;
    }
    .sub-left { font-size: 13px; color: #999; }
    .sub-right { font-size: 13px; color: #2f6fed; cursor: pointer; }
    .sub-right:active { opacity: 0.7; }

    /* 提交按钮 */
    .submit-wrap { margin: 10px 14px 18px; }
    .submit-btn {
        width: 100%;
        height: 48px;
        border: none;
        border-radius: 10px;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        background: linear-gradient(90deg, #ff6b6b, #ff7e67);
    }
    .submit-btn:disabled { opacity: .45; }

    /* ================== 遮罩/弹窗 ================== */
    .mask {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: flex-end; /* ✅ 默认给底部抽屉 */
    }

    /* ✅ 关键：提示弹窗用居中遮罩（只改 class，不改结构） */
    .mask-center {
        align-items: center;
    }

    /* 底部弹窗 */
    .popup {
        width: 100%;
        background: #fff;
        border-radius: 14px 14px 0 0;
        overflow: hidden;
        padding-bottom: 10px;
    }
    .popup-title {
        padding: 14px 16px;
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        position: relative;
        border-bottom: 1px solid #f3f3f3;
    }
    .popup-setting {
        position: absolute;
        right: 16px;
        top: 14px;
        color: #2f6fed;
        font-size: 14px;
        font-weight: 400;
    }
    .popup-setting:active { opacity: 0.7; }

    .popup-list {
        max-height: 70vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .popup-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #f6f6f6;
        cursor: pointer;
        background: #fff;
    }
    .popup-item:active { background: #fafafa; }
    .popup-item.active { background: rgba(0, 194, 111, 0.06); }

    .item-left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
    }
    .item-text {
        display: flex;
        flex-direction: column;
        min-width: 0;
    }
    .item-title { font-size: 15px; color: #111; }
    .item-desc {
        font-size: 13px;
        color: #999;
        margin-top: 2px;
        max-width: 78vw;
        word-break: break-all;
    }
    .item-desc.ellipsis {
        max-width: 72vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: normal;
    }
    .item-right {
        display: flex;
        align-items: center;
        min-width: 28px;
        justify-content: flex-end;
    }
    .check { color: #00c26f; font-size: 18px; margin-right: 0; }
    .chevron { color: #c7c7c7; font-size: 20px; line-height: 1; }

    .popup-cancel {
        margin: 10px 16px 0;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #f5f5f5;
        border-radius: 10px;
        font-size: 15px;
        color: #333;
        cursor: pointer;
    }
    .popup-cancel:active { opacity: 0.7; }
    .safe-bottom { height: env(safe-area-inset-bottom); }

    /* 提示弹窗 */
    .no-account-modal {
        width: 72%;
        background: #fff;
        border-radius: 12px;
        padding: 22px 16px 16px;
        text-align: center;
    }
    .modal-title {
        font-size: 17px;
        font-weight: 700;
        color: #111;
        margin-bottom: 10px;
    }
    .modal-desc {
        font-size: 14px;
        color: #999;
        line-height: 1.6;
        margin-bottom: 18px;
    }
    .modal-btn {
        font-size: 16px;
        color: #ff4d4f;
        font-weight: 600;
        padding-top: 10px;
        border-top: 1px solid #f0f0f0;
    }
    .modal-btn:active { opacity: 0.7; }

    /* 动画 */
    .fade-enter-active,
    .fade-leave-active { transition: opacity 0.18s ease; }
    .fade-enter-from,
    .fade-leave-to { opacity: 0; }

    .slide-up-enter-active,
    .slide-up-leave-active { transition: transform 0.2s ease; }
    .slide-up-enter-from,
    .slide-up-leave-to { transform: translateY(100%); }
</style>
